angular.module('omfm').directive('wkColumnSelector', WkColumnSelectorDirective);

WkColumnSelectorDirective.$inject = [];

function WkColumnSelectorDirective() {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {
			availableTables: '=tables',
			fields: '=',
			col: "=",
			simple: "=?",
		},
		templateUrl: "/app/omfm/templates/wkColumnSelector.html",
		link:        function ($scope) {
			$scope.filterOperators = [
				{operator: '='},
				{operator: '>'},
				{operator: '<'},
				{operator: '>='},
				{operator: '<='},
				{operator: 'in'},
				{operator: 'like'},
			];

			$scope.setCol = function(){
				let newCol = $scope.fields[$scope.col.table].filter(function(i){
					return i.name == $scope.col.column
				})[0];

				$scope.col.type = newCol.type;
				$scope.col.title = newCol.title;
			}
		}
	}
}